import React from 'react';
import './Disputes.css';
import { MainContainer } from '../../../../../components/MainContainer/MainContainer';
import SelfRates from '../../components/SelfRate/SelfRates';
import SelfStats from '../../components/SelfState/SelfStats';
import { Content } from '../components/Content/Content';

export const Disputes: React.FC = () => (
  <MainContainer>
    <div className="disputes merchant-page">
      <header className="merchant-page__header">
        <div>
          <span className="merchant-page__eyebrow">КОНТРОЛЬ</span>
          <h1>Споры</h1>
          <p>Заявки, требующие дополнительной проверки</p>
        </div>
      </header>
      <SelfRates />
      <SelfStats />
      <h2 className="merchant-section-title">Все споры</h2>
      <Content />
    </div>
  </MainContainer>
);

export default Disputes;
